import { LSystem } from "./lsystem";
import { LSystemModelBuilder } from "./lsystem-model-builder";

export class LSystemFactory {
    private constructor() {}

    static createSmallFern(seed = "plantito") {
        return new LSystem({
            start: "P",
            rules: {
                P: [
                    {
                        rule: "FFFB+(5)P",
                        prob: 0.4,
                    },
                    {
                        rule: "FFB+(2)P",
                        prob: 0.2,
                    },
                    {
                        rule: "FFB-(3)P",
                        prob: 0.1,
                    },
                    {
                        rule: "FFFB+(8)P",
                        prob: 0.1,
                    },
                    {
                        rule: "FFB-(7)P",
                        prob: 0.1,
                    },
                    {
                        rule: "FFBP",
                        prob: 0.1,
                    },
                ],
                B: [
                    {
                        rule: "[-(15)C][+(15)C]",
                        prob: 0.5,
                    },
                    {
                        rule: "[-(20)C][+(20)C]",
                        prob: 0.3,
                    },
                    {
                        rule: "[-(5)C][+(8)C]",
                        prob: 0.1,
                    },
                    {
                        rule: "[-(8)C][+(5)C]",
                        prob: 0.1,
                    },
                ],
                C: [
                    {
                        rule: "F[E(2,2)]",
                        prob: 0.5,
                    },
                    {
                        rule: "F[B]",
                        prob: 0.5,
                    },
                ],
            },
            seed,
            maxGenerations: 20,
        });
    }

    static createDefaultModelBuilder(
        ctx: CanvasRenderingContext2D,
        width: number,
        height: number,
        positionXPercentage: number,
        scale: number,
        dark: boolean,
        swayAngle: number,
    ) {
        return new LSystemModelBuilder<{
            position: { x: number; y: number };
            angle: number;
            scale: number;
            width: number;
            lightness: number;
            stateStack: any[];
        }>({
            initialState: {
                position: {
                    x: positionXPercentage * width,
                    y: height,
                },
                angle: 90,
                scale,
                width: 5,
                lightness: dark ? 10 : 35,
                stateStack: [],
            },
        })
            .addHook(() => {
                ctx.clearRect(0, 0, width, height);
            })
            .addDrawingRule("P", (state) => state)
            .addDrawingRule("B", (state) => state)
            .addDrawingRule("C", (state) => state)
            .addDrawingRule("F", (state, [length]) => {
                const { angle, position } = state;
                length ||= 10;
                length *= state.scale;
                const angleInRad = (angle * Math.PI) / 180;
                const endPosition = {
                    x: position.x - length * Math.cos(angleInRad),
                    y: position.y - length * Math.sin(angleInRad),
                };

                ctx.save();
                ctx.strokeStyle = `hsla(132, 63%, ${state.lightness}%, 1.00)`;
                ctx.lineWidth = state.width;
                ctx.beginPath();
                ctx.moveTo(position.x, position.y);
                ctx.lineTo(endPosition.x, endPosition.y);
                ctx.stroke();
                ctx.closePath();
                ctx.restore();

                return {
                    ...state,
                    position: endPosition,
                    lightness: dark
                        ? Math.min(state.lightness + 1, 60)
                        : Math.max(state.lightness - 1, 10),
                    width: Math.max(1, state.width - 0.2),
                };
            })
            .addDrawingRule("f", (state, [length]) => {
                const { angle, position } = state;
                length ||= 10;
                length *= state.scale;
                const angleInRad = (angle * Math.PI) / 180;
                const endPosition = {
                    x: position.x - length * Math.cos(angleInRad),
                    y: position.y - length * Math.sin(angleInRad),
                };
                return {
                    ...state,
                    position: endPosition,
                };
            })
            .addDrawingRule("[", (state) => {
                return {
                    ...state,
                    stateStack: state.stateStack.concat({
                        ...state,
                        stateStack: [...state.stateStack],
                    }),
                    // width: state.width > 1 ? state.width - 0.5 : state.width,
                };
            })
            .addDrawingRule("]", (state) => {
                const prev = state.stateStack[state.stateStack.length - 1];
                return {
                    ...prev,
                    stateStack: state.stateStack.slice(0, -1),
                };
            })
            .addDrawingRule("+", (state, [angle]) => {
                angle ||= 45;
                return {
                    ...state,
                    angle: state.angle + angle + swayAngle,
                };
            })
            .addDrawingRule("-", (state, [angle]) => {
                angle ||= 45;
                return {
                    ...state,
                    angle: state.angle - angle + swayAngle,
                };
            })
            .addDrawingRule("E", (state, [radiusX, radiusY]) => {
                radiusX ||= 3;
                radiusY ||= 5;
                radiusX *= state.scale;
                radiusY *= state.scale;
                const { position } = state;
                ctx.save();
                ctx.strokeStyle = "orange";
                ctx.lineWidth = 2;
                ctx.beginPath();

                ctx.ellipse(
                    position.x,
                    position.y,
                    radiusX,
                    radiusY,
                    0,
                    0,
                    Math.PI * 2,
                );
                ctx.stroke();
                ctx.closePath();
                ctx.restore();

                return state;
            });
    }
}
